import { render, staticRenderFns } from "./RentManagement.vue?vue&type=template&id=234cfa78&"
import script from "./RentManagement.vue?vue&type=script&lang=js&"
export * from "./RentManagement.vue?vue&type=script&lang=js&"
import style0 from "./RentManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports